import React from 'react';
import { InvestorsPageV2 } from './InvestorsPageV2';

/**
 * Manage Investors now always renders the v2 experience for authenticated users.
 * The old feature-flag branch was intentionally removed so a stale DB flag or
 * impersonation mismatch cannot send real users back to the legacy page.
 */
export const InvestorsPageGate: React.FC = () => {
  return <InvestorsPageV2 />;
};

export default InvestorsPageGate;
